import { render, staticRenderFns } from "./MISLayout.vue?vue&type=template&id=6ef39dc2"
import script from "./MISLayout.vue?vue&type=script&lang=js"
export * from "./MISLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports